import React, { useEffect } from 'react'
import { GatekeeperFlag, IsGatekeeperEnabled } from 'src/context/Gatekeeper'
import { SignUpPage } from './SignUpPage'
import { PLG_SIGNUP_REDIRECT_URL, SignUpProps } from './SignUpPage.constants'

/**
 * Redirects the browser to an external URL. React Router's <Navigate> only
 * handles in-app routes, so we use window.location for off-app destinations.
 */
const ExternalRedirect = ({ to }: { to: string }): null => {
  useEffect(() => {
    window.location.replace(to)
  }, [to])
  return null
}

/**
 * Renders the self-serve signup page, or — when PLG signup is not allowed
 * (GatekeeperFlag.ALLOW_PLG_SIGNUP) — redirects to the marketing demo page.
 * Used by every route tree that exposes a signup route (AppUnauth,
 * SaasBuyerApp, SaasProviderApp) so the gating stays consistent.
 */
export const SignUpPageOrRedirect = (props: SignUpProps): JSX.Element =>
  IsGatekeeperEnabled(GatekeeperFlag.ALLOW_PLG_SIGNUP) ? (
    <SignUpPage {...props} />
  ) : (
    <ExternalRedirect to={PLG_SIGNUP_REDIRECT_URL} />
  )
